/**
 * AdminActividadTicketsWalletsPasarelasView — Web Component (Light DOM)
 *
 * Vista de Actividad del panel de administración.
 * Un tab por canal de venta — la mesa transaccional del día:
 *   - Tickets: canal físico — KPIs de ventas, buscador por código, tabla con cobrar/anular.
 *   - Wallet: canal digital — KPIs y movimientos de wallet (lógica en FinanzasModule, UI acá).
 *   - Integradores: canal de terceros — transacciones de integradores externos.
 * Migrado desde index.html (sección Actividad).
 */
import { t } from '../../services/i18n-admin.js';
import { icon } from '../../utils/icon.js';

export class AdminActividadTicketsWalletsPasarelasView extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
                    <!-- ACTIVIDAD VIEW -->
                    <section class="view" id="view-actividad">
                        <div class="section-header">
                            <h3 class="section-title">${t('Operación')}</h3>
                            <div class="view-tabs">
                                <button
                                    class="tab-btn active"
                                    data-tab="tickets"
                                    data-action="app:switchTab"
                                    data-view="actividad"
                                >
                                    ${icon('ticket')} ${t('Tickets')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="wallet"
                                    data-action="app:switchTab"
                                    data-view="actividad"
                                >
                                    ${icon('wallet')} Wallet
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="integradores"
                                    data-action="app:switchTab"
                                    data-view="actividad"
                                >
                                    ${icon('arrow-left-right')} ${t('Integradores')}
                                </button>
                            </div>
                        </div>

                        <!-- TAB: Tickets (tab por defecto de Operación) -->
                        <div class="tab-content active" id="tab-actividad-tickets">
                            <div class="view-tabs" style="margin-bottom:16px;">
                                <button class="tab-btn active" data-subtab="recentes" data-action="tickets:switchBilhetesSubtab">
                                    ${icon('ticket')} ${t('Recientes')}
                                </button>
                                <button class="tab-btn" data-subtab="premios" data-action="tickets:switchBilhetesSubtab">
                                    ${icon('banknote')} ${t('Premios por Pagar')}
                                </button>
                            </div>
                            <div id="bilhetes-subtab-recentes">
                            <!-- KPIs de tickets -->
                            <div class="kpi-grid">
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Vendidos Hoy')}</div>
                                    <div class="kpi-value" id="ticketsVendidosHoy"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Por Cobrar')}</div>
                                    <div class="kpi-value orange" id="ticketsPorCobrar"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Apostado Hoy')}</div>
                                    <div class="kpi-value green" id="ticketsApostadoHoy"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Pagado Hoy')}</div>
                                    <div class="kpi-value blue" id="ticketsPagadoHoy"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Vencen en 7 días')}</div>
                                    <div class="kpi-value orange" id="ticketsPorExpirar"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                                </div>
                            </div>

                            <!-- Busqueda rapida -->
                            <div
                                class="ticket-search-bar"
                                style="margin: 16px 0; display: flex; gap: 12px; align-items: center"
                            >
                                <div style="position: relative; flex: 1; max-width: 300px">
                                    <img
                                        src="/assets/icons/search.svg"
                                        class="icon"
                                        style="
                                            position: absolute;
                                            left: 12px;
                                            top: 50%;
                                            transform: translateY(-50%);
                                            width: 18px;
                                            height: 18px;
                                        "
                                        alt=""
                                    />
                                    <input
                                        type="text"
                                        id="ticketSearchInput"
                                        class="form-input"
                                        placeholder="${t('Buscar por codigo (ABC12345)...')}"
                                        style="padding-left: 40px; text-transform: uppercase"
                                        data-action="tickets:searchOnEnter"
                                    />
                                </div>
                                <button class="btn btn-primary" data-action="tickets:searchTicket">
                                    ${icon('search')}
                                    <span>${t('Buscar')}</span>
                                </button>
                            </div>

                            <!-- Tabla de tickets — renderizado por ListadoConFiltrosYExport -->
                            <div id="listado-tickets-container"></div>
                            </div>
                            <!-- Sub-tab Prêmios por Pagar: circulante del canal físico — tickets ganadores
                                 sin cobrar (mudado desde Finanzas → Saldos; render en platform-saldos-red.js). -->
                            <div id="bilhetes-subtab-premios" style="display:none">
                                <div id="saldos-red-seccion-pagos-delegados-pendientes"></div>
                            </div>
                        </div>

                        <!-- TAB: Wallet (movimientos de wallet — mudado desde Finanzas: es flujo del día por canal digital) — KPIs propios (par entrada/salida por columna) + timeline
                             arriba, tabla renderizada por ListadoConFiltrosYExport en un SUB-div propio
                             (#listado-movimientos-container) — el componente hace innerHTML = sobre su
                             contenedorElemento, así que no puede ser el mismo nodo que switchTab
                             muestra/oculta (perdería el KPI-grid en el próximo repintado). -->
                        <div class="tab-content" id="tab-actividad-wallet" style="display: none">
                            <div class="view-tabs" style="margin-bottom:16px;">
                                <button class="tab-btn active" data-subtab="movimentos" data-action="finanzas:switchWalletSubtab">
                                    ${icon('list')} ${t('Movimientos')}
                                </button>
                                <button class="tab-btn" data-subtab="circulante" data-action="finanzas:switchWalletSubtab">
                                    ${icon('hand-coins')} ${t('Circulante')}
                                </button>
                            </div>
                            <div id="wallet-subtab-movimentos">
                            <div id="movimientos-timeline-maestra" style="margin-bottom:16px;"></div>
                            <div class="kpi-grid kpi-grid--4col">
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Jugado')}</div>
                                    <div class="kpi-value green" id="movJogado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                    <div class="kpi-sublabel">${t('Total apostado en el período')}</div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Depósito')}</div>
                                    <div class="kpi-value green" id="movDeposito"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                    <div class="kpi-sublabel">${t('Total depositado en el período')}</div>
                                </div>
                                <div class="kpi-card" title="${t('Cuánto se jugó usando saldo de origen bônus en el período')}">
                                    <div class="kpi-label">${t('Bônus')}</div>
                                    <div class="kpi-value green" id="movBonus"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                    <div class="kpi-subvalor" id="movBonusOutorgado"></div>
                                    <div class="kpi-sublabel">${t('Jugado con saldo de bônus en el período')}</div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Movimientos')}</div>
                                    <div class="kpi-value" id="movTotal"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                                    <div class="kpi-sublabel">${t('Total de movimientos en el período')}</div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Premiado')}</div>
                                    <div class="kpi-value orange" id="movPremiado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                    <div class="kpi-sublabel">${t('Total pagado en premios en el período')}</div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Retiro')}</div>
                                    <div class="kpi-value orange" id="movRetiro"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                    <div class="kpi-sublabel">${t('Total retirado en el período')}</div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Rejuego')}</div>
                                    <div class="kpi-value blue" id="movRejuego"><span class="skeleton-bar" style="display:inline-block;width:50px;height:20px;"></span></div>
                                    <div class="kpi-sublabel">${t('% de lo jugado que ya circulaba (no es dinero fresco)')}</div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Jugadores Activos')}</div>
                                    <div class="kpi-value" id="movJogadoresAtivos"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                                    <div class="kpi-sublabel">${t('Clientes distintos con movimientos en el período')}</div>
                                </div>
                            </div>
                            <div id="listado-movimientos-container"></div>
                            </div>
                            <!-- Sub-tab Circulante: pasivo con jugadores del canal digital — dinero cargado
                                 en wallets y aún no jugado/retirado (foto actual, no flujo). -->
                            <div id="wallet-subtab-circulante" style="display:none">
                                <div class="kpi-grid kpi-grid--4col">
                                    <div class="kpi-card">
                                        <div class="kpi-label">${t('Total en wallets')}</div>
                                        <div class="kpi-value" id="walletCircTotal"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                        <div class="kpi-sublabel">${t('Dinero cargado y aún no jugado ni retirado')}</div>
                                    </div>
                                    <div class="kpi-card">
                                        <div class="kpi-label">${t('Saldo real')}</div>
                                        <div class="kpi-value green" id="walletCircReal"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                        <div class="kpi-sublabel">${t('Depósitos y premios acreditados')}</div>
                                    </div>
                                    <div class="kpi-card">
                                        <div class="kpi-label">${t('Bônus vigente')}</div>
                                        <div class="kpi-value orange" id="walletCircBonus"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                                        <div class="kpi-sublabel">${t('Bonus otorgado sin expirar (no retirable)')}</div>
                                    </div>
                                    <div class="kpi-card">
                                        <div class="kpi-label">${t('Jugadores con saldo')}</div>
                                        <div class="kpi-value blue" id="walletCircClientes"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                                        <div class="kpi-sublabel">${t('Clientes con dinero en la wallet ahora')}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- TAB: Integradores -->
                        <div class="tab-content" id="tab-actividad-integradores" style="display: none">
                            <div class="kpi-grid">
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Transacciones Hoy')}</div>
                                    <div class="kpi-value" id="integradoresTotal"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Tasa de Exito')}</div>
                                    <div class="kpi-value green" id="integradoresExito"><span class="skeleton-bar" style="display:inline-block;width:50px;height:20px;"></span></div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('GGR Hoy')}</div>
                                    <div class="kpi-value blue" id="integradoresGgr">---</div>
                                </div>
                                <div class="kpi-card">
                                    <div class="kpi-label">${t('Latencia Prom.')}</div>
                                    <div class="kpi-value orange" id="integradoresLatencia">---</div>
                                </div>
                            </div>
                            <div id="listado-integradores-container"></div>
                        </div>

                    </section>
        `;
    }
}

customElements.define('admin-actividad-tickets-wallets-pasarelas-view', AdminActividadTicketsWalletsPasarelasView);
